'use client'
import TeamImage from "@/app/pwa/components/TeamImage";
import { MatchOutcome } from "@/sources/kicker-amateur/types";
import Link from "next/link";
import { useParams } from "next/navigation";
import {pwaTeamGamePath} from "@/utils/urlHelper";

export function MatchResult({ match }: { match: MatchOutcome }) {
  const {teamId} = useParams()
  // TODO:Andrej TODO:Timo this should link to the match actually
  return (
    <Link href={pwaTeamGamePath(teamId.toString(), match.matchId.toString(), {tab:"organisation"})} className="flex flex-col items-center justify-center gap-y-1 bg-gray-100 flex-1">
      <span className={`
        w-full text-center text-white-forced text-sm font-compressed font-bold
        ${match.result.state === "win" ? "bg-accent" : ""}
        ${match.result.state === "draw" ? "bg-gray-200" : ""}
        ${match.result.state === "loss" ? "bg-primary-variant" : ""}
        `}>
        {match.result.title}
      </span>
      <div className="py-0.5 px-1.5 pb-2">
        { match.team && <TeamImage team={match.team} size={"10"} />}
      </div>
    </Link>
  );
}
